import { Helmet } from 'react-helmet-async';
// sections
import { AboutView } from 'src/sections/about/view';

// ----------------------------------------------------------------------

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Cartify | Leading F&B Supply Chain Platform</title>

        {/* Primary Meta Tags */}
        <meta name="title" content="About Cartify | Leading F&B Supply Chain Platform" />
        <meta
          name="description"
          content="Discover how Cartify is revolutionizing F&B supply chain management. Trusted by numerous businesses, we provide seamless ordering solutions with proven customer satisfaction. Learn about our mission and success stories."
        />
        <meta
          name="keywords"
          content="Cartify about us, F&B platform history, food supply chain solutions, restaurant supply platform, Cartify testimonials, F&B business solutions"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.cartify.org/about-us" />
        <meta property="og:title" content="About Cartify | Leading F&B Supply Chain Platform" />
        <meta
          property="og:description"
          content="Discover how Cartify is revolutionizing F&B supply chain management. Trusted by numerous businesses, we provide seamless ordering solutions with proven customer satisfaction."
        />
        <meta
          property="og:image"
          content="https://www.cartify.org/assets/images/about/chef-love.jpg"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.cartify.org/about-us" />
        <meta
          property="twitter:title"
          content="About Cartify | Leading F&B Supply Chain Platform"
        />
        <meta
          property="twitter:description"
          content="Discover how Cartify is revolutionizing F&B supply chain management. Trusted by numerous businesses, we provide seamless ordering solutions with proven customer satisfaction."
        />
        <meta
          property="twitter:image"
          content="https://www.cartify.org/assets/images/about/chef-love.jpg"
        />

        {/* Additional Meta Tags */}
        <link rel="canonical" href="https://www.cartify.org/about-us" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <AboutView />
    </>
  );
}
